module.exports = __webpack_public_path__ + "img/Map.d8f368c1.svg";